import { BankSiteKey, bankSiteQueryMap, IlfProgramKey, ilfProgramQueryMap } from './types';
import { currentEnv, getSearchParams, mitigationOrIlfUrls } from './helpers';

const serviceRoot = '/api/ribits/';

export const RibitsEndpoints = {
  // Queries ---------------------------------------------------------------------------------------

  getBankSiteList: (key: BankSiteKey, value: string) => {
    const queryProperty = bankSiteQueryMap[key] || 'kind_of_bank';
    const query = `{ "${queryProperty}": "${value}" }`;
    const queryString = getSearchParams(query);

    return `${serviceRoot}bankSite${queryString.toString()}`;
  },

  getIlfProgramList: (key: IlfProgramKey, value: string) => {
    const queryProperty = ilfProgramQueryMap[key] || 'district';
    const query = `{ "${queryProperty}": "${value}" }`;
    const queryString = getSearchParams(query);

    return `${serviceRoot}ilfProgram${queryString}`;
  },

  getMitigationBanksOrIlf: (mitigationType: string, latitude: number, longitude: number) => {
    const baseUrl =
      mitigationType === 'Mitigation Bank' ? mitigationOrIlfUrls.mitigationBank : mitigationOrIlfUrls.inLieuFee;
    const queryString = `?longitude=${longitude}&latitude=${latitude}`;
    const prefix = currentEnv === 'local' ? '/ribits' : '';

    return `${prefix}${baseUrl}${queryString}`;
  },
};
